<article *ngIf="tailoringConditions; else showNone">
	<ul class="list dense">
		<li class="list-item" *ngFor="let entry of tailoringConditions | mergeConditions">
			<div class="query">
				<h6 *ngIf="entry.breadcrumb">{{ entry.breadcrumb }}</h6>
				<h4>{{ entry.query.name }}</h4>
				<ul class="list dense">
					<li class="answer" *ngFor="let answer of entry.query.answers">
						<a
							[routerLink]="['../../../management/tailoring/' + answer.identity]"
							*ngIf="answer.allowedOperations.ACCESS_TAILORING_RESOURCES"
						>
							<h4>{{ answer.name }}</h4>
						</a>
						<h4 *ngIf="!answer.allowedOperations.ACCESS_TAILORING_RESOURCES">{{ answer.name }}</h4>
						<p
							class="subtypes"
							*ngFor="let type of answer.conditionTypes"
							translate="management.tailoring.answer.{{ type }}"
						>
							<!--remove span-->
						</p>
					</li>
				</ul>
			</div>
		</li>
	</ul>
</article>

<ng-template #showNone>
	<article *ngIf="translateNone">
		<p class="empty" [translate]="translateNone"></p>
	</article>
</ng-template>
